module.exports = __webpack_public_path__ + "img/delete.4ba32ddf.png";